<article>

  <section class="hero-gradient-express py-4 py-md-5">
    <div class="container py-md-5">
      <img alt="Adobe Express"
           ngSrc="assets/images/adobe/express.svg"
           class="express-logo"
           height="192"
           width="192"/>

      <div class="row">
        <h1 class="d-flex mt-4 mt-md-5 fw-bold display-6 align-items-center col-12 col-xl-8">
          Unleash Your Creative Potential with Adobe Express Premium
        </h1>

        <p class="mt-4 fs-5 fw-bold col-12 col-xl-8">
          University of Utah students, faculty, and full-time staff can access Adobe Express Premium for free!
          This user-friendly platform is available through your web browser or the Adobe Express mobile app.
          <span class="text-decoration-underline">Simply log in with your University of Utah credentials (unid&#64;umail.utah.edu)</span>
          to unlock a wide range of powerful tools and resources,
          including premium templates, fonts, and design assets.
          Whether you're working on a class project, creating engaging content, or enhancing presentations,
          Adobe Express makes it easy to bring your creative vision to life.
        </p>
      </div>

      <div class="flex-shrink-0">
        <app-adobe-express-info-access></app-adobe-express-info-access>
      </div>
    </div>
  </section>

  <section class="py-5">
    <div class="my-5">
      <div class="container py-4">
        <h2 class="display-6 fw-bold text-center">
          The quick and easy <!-- Fix orphan --><span class="d-inline-block">create-anything app</span>
        </h2>

        <div class="row justify-content-center">
          <p class="mt-4 fs-5 fw-bold text-center col-12 col-xl-8">
            Adobe Express is a powerful, easy-to-use tool that allows faculty, staff, and students
            to create stunning, professional-quality designs, videos, and web pages in minutes.
            With its drag-and-drop interface and vast library of templates, fonts, and graphics,
            Adobe Express is perfect for everything from class projects and presentations
            to social media content and departmental marketing materials.
          </p>
        </div>

        <div>
          <ol class="grid mt-4 ms-0">
            <li class="g-col-12 g-col-md-4 d-flex flex-column align-items-center">
              <img ngSrc="assets/images/adobe/express-landing-icons/noun-play-button-6923693.svg"
                   width="48"
                   height="48"
                   alt="Video">
              <p class="mt-2">
                Combine video clips, artwork, animations and music to make videos with drag and drop ease.
              </p>
            </li>

            <li class="g-col-12 g-col-md-4 d-flex flex-column align-items-center">
              <img ngSrc="assets/images/adobe/express-landing-icons/noun-pdf-2956528.svg"
                   width="48"
                   height="48"
                   alt="PDFs">
              <p class="mt-2">
                Import files to create, edit and combine PDFs.
            </li>

            <li class="g-col-12 g-col-md-4 d-flex flex-column align-items-center">
              <img ngSrc="assets/images/adobe/express-landing-icons/noun-effect-4818679.svg"
                   width="48"
                   height="48"
                   alt="Effects">
              <p class="mt-2">
                Generate extraordinary text effects and images instantly from just a description with generative AI, powered by Adobe Firefly.
            </li>

            <li class="g-col-12 g-col-md-4 d-flex flex-column align-items-center">
              <img ngSrc="assets/images/adobe/express-landing-icons/noun-template-2253782.svg"
                   width="48"
                   height="48"
                   alt="Templates">
              <p class="mt-2">
                Get started quickly with thousands of free templates, Adobe Stock photos, videos, music and more.
            </li>

            <li class="g-col-12 g-col-md-4 d-flex flex-column align-items-center">
              <img ngSrc="assets/images/adobe/express-landing-icons/noun-share-7363189.svg"
                   width="48"
                   height="48"
                   alt="Share">
              <p class="mt-2">
                Easily share projects and collaborate with your classmates and teachers.
            </li>

            <li class="g-col-12 g-col-md-4 d-flex flex-column align-items-center">
              <img ngSrc="assets/images/adobe/express-landing-icons/nhoj-mobile-31337.svg"
                   width="56"
                   height="56"
                   alt="Mobile">
              <p class="mt-2">
                Access Adobe Express projects from any device with the mobile app.
            </li>
          </ol>

        </div>

        <div class="bg-light mt-5 col-12 col-lg-7 p-5 mx-auto d-flex flex-md-row flex-column">
          <div class="me-5 mb-2 mb-md-0">
            <img ngSrc="assets/images/adobe/creative-cloud.svg"
                 alt="Adobe Creative Cloud"
                 width="64"
                 height="64"
            >

          </div>
          <div>
            <h2>Need Adobe Creative Cloud Pro?</h2>
            <a routerLink="/adobe/creative-cloud">Learn more and request access</a>
          </div>
        </div>
      </div>
    </div>

  </section>

  <app-adobe-express-info-instructions />

  <app-adobe-shared-creative-campus-blurb />

  <app-adobe-express-cc-apps-blurb />

  <app-adobe-shared-aup />

</article>
